import { setTheme } from "theme/default/setTheme";

export const setBackgroundColor_rgba_246_181_122_40 = setTheme(({ theme }) => `background-color: ${theme.colors.color_rgba_246_181_122_40}`);
